import { render, staticRenderFns } from "./accessoryResume.vue?vue&type=template&id=2db62e65&scoped=true"
import script from "./accessoryResume.vue?vue&type=script&lang=js"
export * from "./accessoryResume.vue?vue&type=script&lang=js"
import style0 from "./accessoryResume.vue?vue&type=style&index=0&id=2db62e65&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2db62e65",
  null
  
)

export default component.exports